import { resilientSwrConfig } from '@side/next-tools/swr';
import type { SWRConfiguration } from 'swr';

/**
 * The org-wide outage-resilience defaults (retry cap, no 4xx retries, the
 * `withRetryStatus` middleware) come from `@side/next-tools/swr`; add any
 * app-specific global options here rather than in either root.
 */
export const globalSwrConfig = {
  ...resilientSwrConfig,
} satisfies SWRConfiguration;
